export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4612.cc4620b4.jpg";